// Global top-of-screen activity bar. Shows background conversion progress and Cesium
// layer loading, independent of the ingest modal. Hidden when idle.

class ActivityBar {
  private el: HTMLElement;
  private fill: HTMLElement;
  private label: HTMLElement;
  private convDone = 0;
  private convTotal = 0;
  private convFailed = 0;
  private loading = 0;

  constructor() {
    this.el = document.createElement("div");
    this.el.className = "activity-bar";
    this.el.innerHTML = `<div class="activity-fill"></div><div class="activity-label"></div>`;
    this.fill = this.el.querySelector(".activity-fill")!;
    this.label = this.el.querySelector(".activity-label")!;
    document.body.append(this.el);
  }

  setConversion(done: number, total: number, failed = 0): void {
    this.convDone = done;
    this.convTotal = total;
    this.convFailed = failed;
    this.render();
  }

  incLoading(): void {
    this.loading++;
    this.render();
  }

  decLoading(): void {
    this.loading = Math.max(0, this.loading - 1);
    this.render();
  }

  private render(): void {
    const converting = this.convTotal > 0 && this.convDone + this.convFailed < this.convTotal;
    const active = converting || this.loading > 0;
    this.el.classList.toggle("show", active);

    if (converting) {
      const pct = Math.round(((this.convDone + this.convFailed) / this.convTotal) * 100);
      this.fill.style.width = `${Math.max(8, pct)}%`;
      this.el.classList.add("determinate");
      const failTxt = this.convFailed ? ` · ${this.convFailed} failed` : "";
      this.label.textContent = `Converting ${this.convDone + this.convFailed}/${this.convTotal}${failTxt}`;
    } else if (this.loading > 0) {
      this.el.classList.remove("determinate");
      this.fill.style.width = "40%";
      this.label.textContent = `Loading ${this.loading} layer${this.loading > 1 ? "s" : ""}…`;
    } else if (this.convTotal > 0) {
      // Conversions just finished - flash "done" briefly, then clear.
      this.el.classList.remove("determinate");
      this.fill.style.width = "100%";
      const failTxt = this.convFailed ? ` (${this.convFailed} failed)` : "";
      this.label.textContent = `Converted ${this.convDone}/${this.convTotal}${failTxt}`;
      this.el.classList.add("show");
      window.setTimeout(() => {
        this.convTotal = 0;
        this.render();
      }, 2500);
    }
  }
}

export const activityBar = new ActivityBar();
